import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { Observable, from } from "rxjs";
import {CognitoService} from "../data/service/cognito.service";
import {LoanApplicationConstant} from "@services/loan-application-constant";


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: CognitoService,private loanApplicationConstants : LoanApplicationConstant) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    const idToken = sessionStorage.getItem(this.loanApplicationConstants.SessionStorageKey.LENDINGMAN_ID_TOKEN);
    if (idToken && request.url.includes("oauth")) {
          request = request.clone({
            setHeaders: {
              Authorization: "Bearer " + idToken
            }
          });

        }
    return next.handle(request).toPromise();
 }
}
